import React from 'react';
import PropTypes from 'prop-types';

export default class MasterElements extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object
    };
    render() {
        const {title, description, title1, title2} = this.props.content;

        return (
            <div className="master-elements">
                <div className="background" />
                <div className="waterDragon" />
                <div className="content">
                    <h1>{title1 && title2 ? <>{title1}<br></br>{title2}</> : title}</h1>
                    <div dangerouslySetInnerHTML={{__html: description}} />
                </div>
            </div>
        );
    }
}

